// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__HeTki","active":"Tabs_active__B93NS"};